import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AbstractView, getAbstractOptions } from '@/module/Author/Abstract';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/$abstractId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { abstractId } = Route.useParams();
  const { data: abstract } = useSuspenseQuery(getAbstractOptions(abstractId));

  return <AbstractView abstract={abstract} />;
}
